import { ActionsUnion, createAction } from "@bookingcom/flights-core";
import { State } from "./state";

import { SBState } from "@bookingcom/flights-searchbox";

export enum ActionTypes {
  setType = "search/setType",
  setFrom = "search/setFrom",
  setTo = "search/setTo",
  setDateRange = "search/setDateRange",
  setDepartureDate = "search/setDepartureDate",
  setReturnDate = "search/setReturnDate",
  setOccupancyAndCabinClass = "search/setOccupancyAndCabinClass",
  setCabinClass = "search/setCabinClass",
  setSortOrder = "search/setSortOrder",
  setPage = "search/setPage",
  setFiltersDraft = "search/setFiltersDraft",
  /* start - flights_split_bounds_us */
  setFiltersDraftOutbound = "search/setFiltersDraftOutbound",
  setFiltersDraftInbound = "search/setFiltersDraftInbound",
  /* end - flights_split_bounds_us */
  resetFiltersDraft = "search/resetFiltersDraft",
  /* start - flights_split_bounds_us */
  resetFiltersDraftOutbound = "search/resetFiltersDraftOutbound",
  resetFiltersDraftInbound = "search/resetFiltersDraftInbound",
  /* end - flights_split_bounds_us */
  applyFilters = "search/applyFilters",
  /* start - flights_split_bounds_us */
  applyFiltersOutbound = "search/applyFiltersOutbound",
  applyFiltersInbound = "search/applyFiltersInbound",
  /* end - flights_split_bounds_us */
  resetFilters = "search/resetFilters",
  /* start - flights_split_bounds_us */
  resetFiltersOutbound = "search/resetFiltersOutbound",
  resetFiltersInbound = "search/resetFiltersInbound",
  /* end - flights_split_bounds_us */
  swapFromTo = "search/swapFromTo",
  resetFiltersButKeep = "search/resetFiltersButKeep",
  setValueFromSB = "setValueFromSB",
  resetFilter = "search/resetFilter",
  /* start - flights_split_bounds_us */
  resetFilterOutbound = "search/resetFilterOutbound",
  resetFilterInbound = "search/resetFilterInbound"
  /* end - flights_split_bounds_us */
}

export const actions = {
  setSortOrder: createAction((sort: State["sort"]) => ({
    type: ActionTypes.setSortOrder,
    payload: { sort }
  })),

  setPage: createAction((page: State["page"]) => ({
    type: ActionTypes.setPage,
    payload: { page }
  })),

  setFiltersDraft: createAction((filtersDraft: State["filtersDraft"]) => ({
    type: ActionTypes.setFiltersDraft,
    payload: { filtersDraft }
  })),

  /* start - flights_split_bounds_us */
  setFiltersDraftOutbound: createAction((filtersDraftOutbound: State["filtersDraftOutbound"]) => ({
    type: ActionTypes.setFiltersDraftOutbound,
    payload: { filtersDraftOutbound }
  })),
  setFiltersDraftInbound: createAction((filtersDraftInbound: State["filtersDraftInbound"]) => ({
    type: ActionTypes.setFiltersDraftInbound,
    payload: { filtersDraftInbound }
  })),
  /* end - flights_split_bounds_us */

  resetFiltersDraft: createAction(() => ({
    type: ActionTypes.resetFiltersDraft,
    payload: {}
  })),

  /* start - flights_split_bounds_us */
  resetFiltersDraftOutbound: createAction(() => ({
    type: ActionTypes.resetFiltersDraftOutbound,
    payload: {}
  })),
  resetFiltersDraftInbound: createAction(() => ({
    type: ActionTypes.resetFiltersDraftInbound,
    payload: {}
  })),
  /* end - flights_split_bounds_us */

  applyFilters: createAction(() => ({
    type: ActionTypes.applyFilters,
    payload: {}
  })),

  /* start - flights_split_bounds_us */
  applyFiltersOutbound: createAction(() => ({
    type: ActionTypes.applyFiltersOutbound,
    payload: {}
  })),
  applyFiltersInbound: createAction(() => ({
    type: ActionTypes.applyFiltersInbound,
    payload: {}
  })),
  /* end - flights_split_bounds_us */

  resetFilters: createAction(() => ({
    type: ActionTypes.resetFilters,
    payload: {}
  })),

  /* start - flights_split_bounds_us */
  resetFiltersOutbound: createAction(() => ({
    type: ActionTypes.resetFiltersOutbound,
    payload: {}
  })),
  resetFiltersInbound: createAction(() => ({
    type: ActionTypes.resetFiltersInbound,
    payload: {}
  })),
  /* end - flights_split_bounds_us */

  resetFiltersButKeep: createAction((filter) => ({
    type: ActionTypes.resetFiltersButKeep,
    payload: { filter }
  })),

  setValueFromSB: createAction((searchboxVal: SBState) => {
    return {
      type: ActionTypes.setValueFromSB,
      payload: { searchboxVal }
    };
  }),

  resetFilter: createAction((filter) => ({
    type: ActionTypes.resetFilter,
    payload: { filter }
  })),

  /* start - flights_split_bounds_us */
  resetFilterOutbound: createAction((filter) => ({
    type: ActionTypes.resetFilterOutbound,
    payload: { filter }
  })),

  resetFilterInbound: createAction((filter) => ({
    type: ActionTypes.resetFilterInbound,
    payload: { filter }
  }))
  /* end - flights_split_bounds_us */
};

export type Actions = ActionsUnion<typeof actions>;
